import { apiClient } from '../../base/ApiClients'
import { useMutation } from 'react-query'
import { ContactInfoFormValues } from '../../../models/b2b/ContactInfo';

export async function submitContactInfo(values: ContactInfoFormValues) {
  return await apiClient.post('/b2b/ContactInfo', values);
}

export const useContactInfoMutation = () => useMutation(submitContactInfo, {});
